import React, { useState } from 'react'
import { Button, Modal } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'
import closeIcon from '../../assets/icons/close.svg'
import { ReactComponent as InfoIcon } from '../../assets/icons/file-plus.svg'

const ModalContent = props => {
  return (
    <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
      {props.children}
    </div>
  )
}

const BorderLine = () => {
  return (
    <div className='bgc-lightgray h2' />
  )
}

const ModalHeader = ({ title, onClose }) => {
  return (
    <>   
      <div className='df jcsb p15'>
        <span className='fz20 ml16 fw600'>{title}</span>
        <button className='bdnone m0 bgc-t' onClick={onClose}>
          <img  src={clear} alt='cancel button'/>
        </button>
      </div>
      <BorderLine />
    </>
  )
}

const ModalFooter = ({ buttonLabel, onClose, onDelete, editScaleTicketHandler }) => {
  const editClick = () => {
    editScaleTicketHandler()
    onClose()
  }
  return (
    <>
      <div className='df jcsb ml25 mr25 mt10'>
        <div>
          {onDelete ? <Button styleType='error' onClick={onDelete}>Delete</Button> : null }
          <Button customClassName="ml10" styleType='success' onClick={editClick}>Edit</Button>
        </div>
        <Button styleType='success' onClick={onClose}>{buttonLabel}</Button>
      </div>
    </>
  )
}

const Section = props => {
  return (
    <>
      <div className='df fxdr fxww w100% p15'>
        {props.children}
      </div>
      <BorderLine />
    </>
  )
}

const Column = props => {
  return (
    <div className='df fxdrc flx1'>
      {props.children}
    </div>
  )
}

const DataRow = ({ label, data }) => {
  return (
    <div className="df fxdrc mb20">
      <span className="mb5 fz15 fw600 w100% c-darkgray">{label}</span>
      <span className="w100%">{data || '-'}</span>
    </div>
  )
}
  
const ScaleTicketDetailModal = ({ data, onDelete, handleDelete, productionPlanId, editScaleTicketHandler }) => {
  const [showModal,setShowModal] = useState(false) 
  const [showDeleteModal,setShowDeleteModal] = useState(false)
  const [showDeleteMsg, setShowDeleteMsg] = useState(false)  
  const { 
    scale_ticket_id,
    scale_ticket_number = '',
    grower_name,      
    scale_ticket_date,
    gross_quantity,
    net_quantity,
    test_weight,
    moisture,
    damage,
    foreign_material,
    rapid_visco_analyzer,
    gross_weight,
    bill_of_lading,
    tare_weight,
    net_weight,
    created,
    notes
  } = data
  const convertDateFromISO = date => {
    if (typeof date === 'string') {
      let returnDate = date && date.split('T')[0].split('-').reverse()
      returnDate = returnDate[1]+'/'+returnDate[0]+'/'+returnDate[2]
      return returnDate
    }
  }

  const handleShowModalClick =() => {
    setShowModal(true)
  }

  return (
    <div>
      {showDeleteMsg ? (
        <div className='df aic jcsb posf t80 l50% bd1-s-lightgray w250 h50 p16 bdrs-4 bgc-white'>
          <span>Scale Ticket Deleted</span>
          <button style={{ 
            background: 'none',
            color: 'inherit',
            border: 'none',
            padding: 0,
            font: 'inherit',
            cursor: 'pointer',
            outline: 'inherit' }}
          onClick={()=>setShowDeleteMsg(false)}
          >
            <img src={closeIcon} alt='cancel icon'/>
          </button>
        </div>  
      ) : null}
      <div 
        className="df aic jcc"
        onClick={handleShowModalClick}
        onKeyDown={e => e.key === 'Enter' && handleShowModalClick()}
        role="button"
        tabIndex={0}
        data-testid="show-scale-ticket"
      >
        <InfoIcon style={{ fill: '#238661', cursor: 'pointer' }} className="w-4 h-4" />
      </div>
      { onDelete ? <Modal
        autoHeight
        show={showDeleteModal}
        handleClose={()=>setShowDeleteModal(false)}
        customModalClassName='z1000'
      >
        <div className='w500 tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          <div className='bb1-s-lightgray df jcsb'>
            <div className='df ml15 mt15 mb15'>
              <div className='fw600 ml10'>
              Delete scale ticket? 
              </div>
            </div>
          </div>
          <div className='p25 h80 df aic jcfs wowb'>
            <span className='wspn fz15'>
              You&#39;re about to permanently delete this scale ticket, 
              reverting the Net Bushels on the scale ticket back to the appropriate inventories.
            </span>
          </div>
          <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={() => setShowDeleteModal(false)}/>
              <Button customClassName='miw70' type='error' text='Delete' 
                onClick={ 
                  async () => {
                    await onDelete(productionPlanId,scale_ticket_id).then(
                      () => {
                        handleDelete()
                        setShowDeleteModal(false)
                        setShowModal(false)
                        setShowDeleteMsg(true)
                      })}}/>
            </div>
          </div>
        </div>
      </Modal>
        : null
      }
      <Modal
        autoHeight
        show={showModal}
        handleClose={()=>setShowModal(false)}
      >
        <ModalContent>
          <ModalHeader title='Scale Ticket Details' onClose={()=>setShowModal(false)} />
          <Section>
            <Column>
              <DataRow label='Grower' data={grower_name} />
              <DataRow label='Ticket Date' data={convertDateFromISO(scale_ticket_date)} />
              <DataRow label='Gross Quantity (bushels)' data={gross_quantity} />
              <DataRow label='Test Weight' data={test_weight} />
              <DataRow label='Damage' data={damage} />
              <DataRow label='RVA' data={rapid_visco_analyzer} />
            </Column>
            <Column>
              <DataRow label='Ticket Number' data={scale_ticket_number} />
              <DataRow label='Net Quantity (bushels)' data={net_quantity} />
              <DataRow label='Bill of Lading (BOL)' data={bill_of_lading} />
              <DataRow label='Moisture' data={moisture} />
              <DataRow label='Foreign Material' data={foreign_material} />
            </Column>
          </Section>
          <Section>
            <Column>
              <DataRow label='Gross Lbs' data={gross_weight} />
              <DataRow label='Net Lbs' data={net_weight} />
            </Column>
            <Column>
              <DataRow label='Tare Lbs' data={tare_weight} />
              <DataRow label='Notes' data={notes} />
            </Column>
          </Section>
          <Section>
            <Column>
              <DataRow label='Date of File Upload' data={convertDateFromISO(created)} />
            </Column>
          </Section>
          <ModalFooter buttonLabel='Close' onClose={() => setShowModal(false)} onDelete={onDelete ? () => setShowDeleteModal(true) : null } editScaleTicketHandler={()=>editScaleTicketHandler(scale_ticket_id, data)} />
        </ModalContent> 
      </Modal>
    </div>
  )
}

export default ScaleTicketDetailModal 